import script from "./InlineChatWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./InlineChatWidget.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__